import React from 'react';
import { Button, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from '@heroui/react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useCommonTranslation } from '@/hooks/useTranslation';

const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme } = useTheme();

  const handleThemeChange = (newTheme: 'light' | 'dark' | 'system') => {
    setTheme(newTheme);
  };

  const { t } = useCommonTranslation();

  const getThemeIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="w-4 h-4" />;
      case 'dark':
        return <Moon className="w-4 h-4" />;
      case 'system':
        return <Monitor className="w-4 h-4" />;
      default:
        return <Monitor className="w-4 h-4" />;
    }
  };

  const getThemeLabel = () => {
    switch (theme) {
      case 'light':
        return t('themeSwitcher.light');
      case 'dark':
        return t('themeSwitcher.dark');
      case 'system':
        return t('themeSwitcher.system');
      default:
        return t('themeSwitcher.system');
    }
  };

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button variant="ghost" className="min-w-0 px-2" startContent={getThemeIcon()}>
          {getThemeLabel()}
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Theme selection"
        onAction={(key) => handleThemeChange(key as 'light' | 'dark' | 'system')}
        selectedKeys={[theme]}
        selectionMode="single"
      >
        <DropdownItem key="light" startContent={<Sun className="w-4 h-4" />}>
          {t('themeSwitcher.light')}
        </DropdownItem>
        <DropdownItem key="dark" startContent={<Moon className="w-4 h-4" />}>
          {t('themeSwitcher.dark')}
        </DropdownItem>
        <DropdownItem key="system" startContent={<Monitor className="w-4 h-4" />}>
          {t('themeSwitcher.system')}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ThemeSwitcher;
